import { render, staticRenderFns } from "./Scrims2ListPage.vue?vue&type=template&id=9782b9a6&scoped=true&"
import script from "./Scrims2ListPage.vue?vue&type=script&lang=js&"
export * from "./Scrims2ListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9782b9a6",
  null
  
)

export default component.exports